import * as React from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { AuthState } from '../types/AuthState';

/**
 * Hook pro načtení stavu přihlášení.
 */
export function useAuth(): AuthState {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider');
  }

  return context;
}
